import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import { useEffect } from 'react'
import { Path, useFieldArray, useFormContext, useWatch } from 'react-hook-form'
import {
    Contract,
    ProductConfigOption,
    ServiceConfigOption,
} from '@/modules/Contract/types'
import useServicePriceTotal from '@/hooks/useServicePriceTotal'
import Component from '../../../Config'

interface ConfigurationProps {
    product_config_options: ProductConfigOption[]
    index: number
    isPOC?: boolean
}

const Configuration: React.FC<ConfigurationProps> = ({
    product_config_options,
    index,
    isPOC = false,
}) => {
    const { t } = useTranslation()
    const { setValue, control } = useFormContext<Contract>()
    const key = `order.products.[${index}].service_configoptions`

    const { fields, remove } = useFieldArray({
        control,
        // @ts-ignore
        name: key,
    })

    const service_configoptions = useWatch({
        control,
        // @ts-ignore
        name: key,
    }) as ServiceConfigOption[]

    const product_form = useWatch({
        control,
        name: `order.products.[${index}].product_form` as Path<Contract>,
    })

    useServicePriceTotal({
        control,
        index,
        service_configoptions,
        setValue,
    })

    useEffect(() => {
        const options = (product_config_options || [])?.map((option) => {
            const oldOption = service_configoptions?.find(
                (s) => s.name === option.name
            )

            return {
                name: option.name,
                unit: option.unit,
                type: option.type,
                prices:
                    option.product_pricing_steps?.length >= 0
                        ? option.product_pricing_steps?.map(
                              // eslint-disable-next-line @typescript-eslint/no-unused-vars
                              ({ product_pricing_step_id, ...rest }) => ({
                                  ...rest,
                              })
                          )
                        : [
                              {
                                  price_start: 0,
                                  price_end: 999999999,
                                  price_per_unit: 0,
                              },
                          ],
                price_config: {
                    method: 'progressive',
                },
                commitment_prepaid: isPOC ? false : true,
                statementable: isPOC ? false : true,
                ...(oldOption || {}),
                commitment_value: product_form === 'commit' ? 1000 : undefined,
                commitment_price_per_unit:
                    product_form === 'commit' ? 0 : undefined,
                commitment_time: product_form === 'commit' ? 1 : undefined,
                product_form,
            }
        })

        // @ts-ignore
        setValue(key, options)
    }, [product_config_options, product_form])

    return (
        <div className="w-full">
            <Typogaphy size="medium" className="font-medium">
                {t('configuration-information')}
            </Typogaphy>

            <div className="mt-4 w-full">
                {fields?.map((option, i) => {
                    // @ts-ignore
                    const Comp = Component[option.type]
                    if (!Comp) return null

                    return (
                        <Comp
                            key={option.id}
                            index={i}
                            isPOC={isPOC}
                            name={key}
                            productIndex={index}
                            remove={remove}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default Configuration
